// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__2Ugro","topBottomGutter":"Layout_topBottomGutter__26R17"};